import { RouteNames } from '@/data/routes';
import { auth0 } from '@/utils/auth0';
import {
  createRoutes,
  getOnboardingCompletionRoute,
} from '@/utils/router-helper';
import { authGuard } from '@auth0/auth0-vue';
import { RouteLocation, NavigationGuardNext } from 'vue-router';
import MainLayout from '@/components/layouts/MainLayout.vue';
import PaymentTransactionsPage from '@/pages/payments/PaymentTransactionsPage.vue';
import store from '@/store';

export default createRoutes(
  {
    path: '/',
    name: RouteNames.HOME.INDEX,
    async beforeEnter(
      to: RouteLocation,
      _from: RouteLocation,
      next: NavigationGuardNext,
    ) {
      if (auth0.isAuthenticated.value) {
        // Fetch user data
        await Promise.all([
          store.dispatchApiAction('FETCH_USER_BANK_ACCOUNTS'),
          store.dispatchApiAction('GET_DEBT_OBLIGATIONS'),
        ]);

        // Update business profile steps before evaluating for routing
        await store.dispatch('UPDATE_ALL_PAYMENTS_BIZ_PROFILE_STEPS');

        const businessProfileSteps = store.getters.businessProfileSteps;
        const routeName = getOnboardingCompletionRoute(businessProfileSteps);
        return next({ name: routeName });
      }

      await authGuard(to);
      return next();
    },
  },
  {
    path: '/home',
    component: MainLayout,
    meta: {
      requiresAuth: true,
      displayNav: true,
    },
    children: [
      {
        path: ':billId?',
        name: RouteNames.HOME.INITIAL,
        alias: '/pay-vendors/payments/:billId?',
        component: PaymentTransactionsPage,
        beforeEnter: authGuard,
      },
    ],
  },
);
